import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getPageIdInfo, loadJS, isZlj, isZZ } from "./common";
import Pagelife from "../lego-pagelife";
import Logger from "./log";
import lego from "../lego";
import { zzsdk } from "./initLoadSdk";

// 定义输出日志的函数
var logInfo = function logInfo(msg, args) {
  Logger.info('setWebViewPageId: '.concat(msg), args);
};

// 支持状态
var support;

// 判断是否支持setWebViewPageId
var checkSupport = function checkSupport() {
  return new Promise(function (resolve) {
    if (support !== undefined) return resolve(support);
    // 判断端内并且支持setWebViewPageId
    if (window && (window.zhuanzhuanMApplication || window.zhuanzhuanMApplicationIos || window.hmos_bridge_service)) {
      window.__ZZAPP__['hasSupportFeature']({
        method: 'setWebViewPageId'
      }, function (res) {
        if (res && res.code == 1) {
          resolve(support = true);
        } else {
          resolve(support = false);
        }
      });
    } else {
      resolve(support = false);
    }
  });
};

// 设置页面ID
var setPageId = function setPageId(pageId) {
  window.__ZZAPP__.run('setWebViewPageId', {
    pageId: pageId
  }, function (res) {
    if (res && res.code == 0) {
      logInfo('sdk的api回调', res);
    }
  });
  // 添加通知埋点
  lego.send({
    pagetype: 'OcdH5Upgrade',
    actiontype: pageId
  });
};

// 加载sdk
var initWebViewPageId = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getPageIdInfo;
    var _ref2,
      _ref2$pageId,
      pageId,
      isSupport,
      _pageId,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$pageId = _ref2.pageId, pageId = _ref2$pageId === void 0 ? '' : _ref2$pageId;
          _context.next = 3;
          return checkSupport();
        case 3:
          isSupport = _context.sent;
          if (!(isSupport !== true)) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          _pageId = pageId || ((_getPageIdInfo = getPageIdInfo()) === null || _getPageIdInfo === void 0 ? void 0 : _getPageIdInfo.pageId) || '';
          logInfo('pageId:' + _pageId);
          if (_pageId) setPageId(_pageId);
          Pagelife.add('onShow', function () {
            var _ref3 = getPageIdInfo() || {},
              pageId = _ref3.pageId;
            logInfo('pageId:' + pageId);
            if (pageId) setPageId(pageId);
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function initWebViewPageId() {
    return _ref.apply(this, arguments);
  };
}();
export var setWebViewPageId = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _ref5,
      _ref5$pageId,
      pageId,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref5 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref5$pageId = _ref5.pageId, pageId = _ref5$pageId === void 0 ? '' : _ref5$pageId;
          try {
            if (isZZ() || isZlj()) {
              if (window.__ZZAPP__) {
                initWebViewPageId({
                  pageId: pageId
                });
              } else {
                loadJS(zzsdk, function () {
                  Logger.info('lego加载sdk成功Ocd');
                  initWebViewPageId({
                    pageId: pageId
                  });
                });
              }
            }
          } catch (error) {
            Logger.error("Ocd\u62A5\u9519".concat(error));
          }
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function setWebViewPageId() {
    return _ref4.apply(this, arguments);
  };
}();